import authorizeLoader from "@/modules/authorize/loader";
import {
  createStatementsAction,
  deleteStatementsAction,
  processStatementAction,
} from "./data";
import { CreateView } from "./views";

const statementsRoutes = [
  {
    path: "statements/new",
    action: createStatementsAction,
    loader: authorizeLoader(),
    element: <CreateView />,
  },

  {
    path: "statements/delete",
    action: deleteStatementsAction,
  },

  {
    path: "statements/:id/process",
    action: processStatementAction,
  },
];
export default statementsRoutes;
